export const DICOM_IGNORE_IMAGE_ORIENTATION_KEY =
  'dicom:ignore-image-orientation';

export const DICOM_FORCE_2D_STACK_KEY = 'dicom:force-2d-stack';

export const DICOM_FORCE_2D_STACK_ID_KEY = 'dicom:force-2d-stack-id';

export const DICOM_FORCE_2D_STACK_INDEX_KEY = 'dicom:force-2d-stack-index';
